module.exports = __webpack_public_path__ + "static/media/semiology-basic.8da7fdee.svg";